import { EDruhDluhopisu } from 'enums/isin/udaje/druhDluhopisu';

const druhDluhopisuSelect = [
    {
        value: EDruhDluhopisu.SD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_SD'
    },
    {
        value: EDruhDluhopisu.BO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_BO'
    },
    {
        value: EDruhDluhopisu.ZL,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_HZL'
    },
    {
        value: EDruhDluhopisu.KO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_KO'
    },
    {
        value: EDruhDluhopisu.PO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_PO'
    },
    {
        value: EDruhDluhopisu.OK,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_OK'
    },
    {
        value: EDruhDluhopisu.OJ,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_OJ'
    }
];
export const druhDluhopisuSelectDLT = [
    {
        value: EDruhDluhopisu.SD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_SD'
    },
    {
        value: EDruhDluhopisu.BO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_BO'
    },
    {
        value: EDruhDluhopisu.ZL,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_HZL'
    },
    {
        value: EDruhDluhopisu.KO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_KO'
    },
    {
        value: EDruhDluhopisu.PO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_DRUH_PO'
    }
];

export default druhDluhopisuSelect;
